import axios from 'axios';

import { BaseUrl } from '../consts';
import { getAuthHead } from '../helpers/auth';
import { ITag } from '../types';

interface IData {
    freeText?: string;
    tags: ITag[];
    isFreeBrowsing?: boolean;
}
export const getFiltersList = async (data: IData) => {
    const auth = await getAuthHead();
    return await axios.post(`${BaseUrl}SmartBrowsing/GetFiltersList`, data, auth);
};
